import { render, staticRenderFns } from "./ForumThreadsListFooter.vue?vue&type=template&id=f2625ab0&"
import script from "./ForumThreadsListFooter.vue?vue&type=script&lang=js&"
export * from "./ForumThreadsListFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports